export default __webpack_public_path__ + "static/media/mb_logo.5ef04e9d.png";